<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="agreement_name"
                                       label="Agreement name"
                                       size="4"
                                       :isFocus="true"
                                       v-model:field="search.agreement_name" />

                        <FormMultiselect fieldName="status_id"
                                         label="Status"
                                         size="4"
                                         :options="select?.statuses"
                                         v-model:field="search.status_id" />
                    </div>
                    <div class="grid">
                        <FormMultiselect fieldName="contractor_id"
                                         label="Contractor"
                                         size="3"
                                         :options="select?.contractors"
                                         v-model:field="search.contractor_id" />

                        <FormMultiselect fieldName="trader_id"
                                         label="Trader"
                                         size="3"
                                         :options="select?.users"
                                         v-model:field="search.trader_id" />

                        <FormSelect fieldName="service_type"
                                    label="Service type"
                                    size="3"
                                    :showClear="true"
                                    :options="select?.service_types"
                                    v-model:field="search.service_type" />

                        <FormMultiselect fieldName="service_id"
                                         label="Service"
                                         size="3"
                                         :options="select?.services"
                                         v-model:field="search.service_id" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ["statuses", "contractors", "users", "service_types", "services"];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
